<template>
  <div class="hulu-page">
    <!-- 背景图容器（全屏占满） -->
    <div class="bg-container">
      <div style="display: flex; align-items: center; justify-content: flex-start;">
        <img src="@/assets/hulu/img_logo.png" style="width: 40px; height: 40px; display: inline-block;" />
        <span style="color: white; font-size: 16px; margin-left: 5px; display: inline-block; vertical-align: middle;">葫芦严选</span>
      </div>
      <!-- 顶部内容区 -->
      <div style="height: 40px"></div>
      <div class="top-card">
        <div class="title">开通购物金 购物更省心</div>
        <div class="sub-title">最高葫芦购物金为</div>
        <div class="x-mark">80000</div>
        <div class="input-wrap">
          <input type="tel" placeholder="请输入手机号" class="phone-input" v-model="mobile"/>
        </div>
        <div class="open-btn-wrap" @click="getMsgCode">
          <van-button class="open-btn" type="danger" round block>
            开通葫芦金
            <span class="tag">通过率高</span>
          </van-button>
        </div>

        <!-- 核心简化：仅给“阅读并同意”单独加span和点击事件 -->
        <div class="agreement-wrap">
          <van-checkbox
              v-model="agree"
              icon-size="14px"
              checked-color="#F85F49"
              class="agreement-checkbox"
          />
          <span class="agreement-text">
            <!-- 仅这几个字可点击切换勾选 -->
            <span class="clickable-text" @click="toggleAgree">阅读并同意</span>
            <a
                href="https://shop.huluyanxuan.com/protocol.html"
                class="agreement-link"
                target="_blank"
                rel="noopener noreferrer"
            >《用户协议》</a>
            和
            <a
                href="https://shop.huluyanxuan.com/privacy.html"
                class="agreement-link"
                target="_blank"
                rel="noopener noreferrer"
            >《隐私政策》</a>
          </span>
        </div>
      </div>

      <!-- 三步开通模块 -->
      <div class="step-card">
        <img class="step-title" src="@/assets/hulu/img_t0.png" alt="三步开通" />
        <div class="step-container">
          <div class="step-item">
            <div class="step-num">1</div>
            <div class="step-text">填写手机号</div>
          </div>
          <div class="arrow-wrapper">
            <img class="step-arrow" src="@/assets/hulu/img_jt.png" alt="箭头" />
          </div>
          <div class="step-item">
            <div class="step-num">2</div>
            <div class="step-text">填个人资料</div>
          </div>
          <div class="arrow-wrapper">
            <img class="step-arrow" src="@/assets/hulu/img_jt.png" alt="箭头" />
          </div>
          <div class="step-item">
            <div class="step-num">3</div>
            <div class="step-text">领取购物金</div>
          </div>
        </div>
      </div>

      <!-- 了解葫芦金区域 -->
      <div class="feature-card">
        <img class="feature-title" src="@/assets/hulu/img_t1.png" alt="了解葫芦金" />
        <div class="feature-grid">
          <div class="feature-item">
            <img src="@/assets/hulu/icon_hlzs.png" alt="葫芦专属" />
            <div class="feature-content">
              <div class="feature-name">葫芦专属</div>
              <div class="feature-desc">本购物金仅限葫芦严选购物使用</div>
            </div>
          </div>
          <div class="feature-item">
            <img src="@/assets/hulu/icon_hlxy.png" alt="葫芦信用" />
            <div class="feature-content">
              <div class="feature-name">葫芦信用</div>
              <div class="feature-desc">先享后付纯信用 下月还很轻松</div>
            </div>
          </div>
          <div class="feature-item">
            <img src="@/assets/hulu/icon_hlld.png" alt="葫芦亮点" />
            <div class="feature-content">
              <div class="feature-name">葫芦亮点</div>
              <div class="feature-desc">30天免息循环购物更省心</div>
            </div>
          </div>
          <div class="feature-item">
            <img src="@/assets/hulu/icon_hlxd.png" alt="葫芦兄弟" />
            <div class="feature-content">
              <div class="feature-name">葫芦兄弟</div>
              <div class="feature-desc">专注于合作企业员工的福利金</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="bottom-tip">
        开通结果以系统评估为准，存在开通失败的情况
      </div>
      <!-- 备案信息 -->
      <div class="beian-info">
        <p>© 深圳市星火嘉科技有限公司 2026 版权所有</p>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">备案号：粤ICP备2025508189号</a>
      </div>
    </div>

    <van-action-sheet v-model="show" title="验证手机" :close-on-click-overlay=false>
      <div>
        <div style="margin: 16px">
          已向手机号 <b>{{mobile}}</b> 发送验证码,5分钟内有效
        </div>
        <div style="height: 50px"></div>
        <van-form>
          <van-field
              v-model="msgCode"
              label="验证码"
              placeholder="请输入短信验证码"
              type="number"
              maxlength="6"
          />
          <div style="height: 10px"></div>
          <div style="margin: 16px;">
            <van-button round block color="#F85F49" @click="login">确认</van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      pid:'',
      money: 25000,
      show:false,
      reportAgree:true,
      mobile: '',
      msgCode: '',
      bizCode:'',
      msgCodeTitle: '发送验证码',
      agree: false,  // 协议勾选状态
      msgCodeDoing: false,
      requesting: false,
      codeSecond: 60,
    };
  },
  mounted() {
    var pid = this.getQueryVariable("pid");
    this.pid = pid;
    if(localStorage.getItem("AUTH_TOKEN") != null){
      this.$router.replace({
        path: "/download",
      });
    }
  },
  methods: {
    getQueryVariable: function (variable) {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return '';
    },
    // 仅切换勾选状态，逻辑极简
    toggleAgree() {
      this.agree = !this.agree;
    },
    check() {
      if (!this.agree) {
        this.$toast.fail("请先阅读并同意《用户协议》和《隐私政策》");
        return false;
      }
      if (!this.pid) {
        this.$toast.fail("错误的地址");
        return false;
      }
      if (!this.mobile) {
        this.$toast.fail("手机号不能为空");
        return false;
      }
      if (this.mobile.length != 11) {
        this.$toast.fail("手机号格式错误");
        return false;
      }
      return true;
    },
    getMsgCode() {
      if (!this.check()) {
        return;
      }
      if (this.msgCodeDoing) {
        return;
      }
      let that = this;
      that.msgCodeDoing = true;
      const params = new URLSearchParams();
      params.append('mobile', that.mobile);
      params.append('promotionId', that.pid);
      that.$http.post("/h5/sendMsg", params).then(function (res) {
        if (res.data.code == 0) {
          if(res.data.data == "1"){
            that.$router.replace({
              path: "/download",
            });
            return;
          }

          that.$toast.success("验证码发送成功");
          that.show = true;
          that.bizCode = res.data.data;
          that.msgCodeDoing = false;
        }else {
          that.msgCodeDoing = false;
        }
      }).catch(function () {
        that.msgCodeDoing = false;
        that.$toast.fail("网络似乎有些不好，请您重试~");
        return;
      });
    },
    login() {
      if (!this.check()) {
        return;
      }
      if (this.bizCode == '') {
        this.$toast.fail("请先获取验证码");
        return;
      }
      if (!this.msgCode) {
        this.$toast.fail("短信验证码不能为空");
        return;
      }
      if (this.requesting) {
        return;
      }
      let that = this;
      that.requesting = true;
      const params = new URLSearchParams();
      params.append('bizCode', that.bizCode);
      params.append('msgCode', that.msgCode);
      params.append('promotionId', that.pid);
      that.$http.post("/h5/login", params).then(function (res) {
        if (res.data.code == 0) {
          let token = res.data.data;
          localStorage.setItem("AUTH_TOKEN",token);
          localStorage.setItem("userMobile",that.mobile);
          that.$router.replace({
            path: "/download",
          });
          return;
        }
        that.requesting = false;
      }).catch(function (e) {
        console.log(e);
        that.requesting = false;
        that.$toast.fail("网络似乎有些不好，请您重试~");
        return;
      });
    },
  }
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
.hulu-page {
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
.bg-container {
  background: url('../assets/hulu/img_bg1.png') no-repeat center/cover;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
}
.top-card {
  background: url('../assets/hulu/img_kuang.png') no-repeat center;
  background-size: contain;
  padding: 25px 16px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(255, 69, 0, 0.2);
  margin-top: 0;
  min-height: 280px;
  box-sizing: border-box;
}
.title {
  font-size: 22px;
  font-weight: bold;
  color: #8B4513;
  margin-bottom: 10px;
  margin-top: 20px;
}
.sub-title {
  font-size: 16px;
  color: #8B4513;
}
.x-mark {
  width: 120px;
  height: 16px;
  text-align: center;
  font-size: 38px;
  font-weight: bold;
  color: #F35B44;
  margin: 0 auto;
  margin-bottom: 60px;
}
.input-wrap {
  margin-bottom: 15px;
  padding: 0 10px;
}
.phone-input {
  width: 100%;
  height: 44px;
  border: 1px solid #F85F49;
  border-radius: 22px;
  padding: 0 15px;
  outline: none;
  box-sizing: border-box;
}
.open-btn-wrap {
  position: relative;
  padding: 0 10px;
}
.open-btn {
  height: 48px;
  font-size: 16px;
  font-weight: bold;
  background-color: #F85F49 !important;
  border: none !important;
}
.tag {
  position: absolute;
  top: 0;
  right: 0px;
  background-color: #F9DE91;
  color: #86512E;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 0 8px 0 8px;
}

/* 协议区域样式（极简） */
.agreement-wrap {
  display: flex;
  align-items: center;  /* 垂直居中对齐 */
  justify-content: center;
  margin-top: 16px;
  font-size: 14px;
}
.agreement-checkbox {
  margin-right: 6px;  /* 复选框与文字间距 */
  flex-shrink: 0;
}
.agreement-text {
  color: #865B2F;
  line-height: 1.4;
}
/* 可点击文字样式（提示用户） */
.clickable-text {
  cursor: pointer;  /* 手型提示 */
}
.agreement-link {
  color: #F85F49 !important;
}

/* 三步开通模块 */
.step-card {
  background: #fff;
  border-radius: 16px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(255, 69, 0, 0.2);
  margin-bottom: 20px;
}
.step-title {
  display: block;
  margin-bottom: 15px;
  height: 26px;
  margin-left: 0;
  margin-right: auto;
}
.step-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  position: relative;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  position: relative;
  z-index: 2;
}
.step-num {
  width: 26px;
  height: 26px;
  line-height: 26px;
  border-radius: 50%;
  background-color: #F85F49;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 0 auto 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step-text {
  font-size: 13px;
  color: #865B2F;
  font-weight: bold;
}
.arrow-wrapper {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  flex-shrink: 0;
}
.step-arrow {
  width: 40px;
  height: auto;
  display: block;
}

/* 了解葫芦金区域 */
.feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(255, 69, 0, 0.2);
  margin-bottom: 30px;
  margin-top: 20px;
}
.feature-title {
  display: block;
  margin-bottom: 10px;
  height: 26px;
}
.feature-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}
.feature-item {
  background: #FFF3E0;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: flex-start;
}
.feature-item img {
  width: 18px;
  height: 18px;
  margin-right: 4px;
  margin-top: 2px;
}
.feature-content {
  flex: 1;
}
.feature-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 3px;
}
.feature-desc {
  font-size: 12px;
  color: #865B2F;
  line-height: 1.2;
}
.bottom-tip {
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding-bottom: 10px;
}
.beian-info {
  font-size: 13px;
  color: #fff;
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
}
.beian-info a {
  color: #fff;
}
</style>